import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "../index.module.css"

/**
 * Modal footer with action buttons (Cancel, Save & Add New, Save)
 */
const ModalFooter = ({ editMode, isSaveEnabled, onCancel, onSaveAndAddNew, onSubmit, saveLoading = false, saveAndAddNewLoading = false }) => {
  const { t } = useTranslation()
  const isAnyLoading = saveLoading || saveAndAddNewLoading

  return (
    <Flex gap={12} align="center" className={styles.modalFooter}>
      <Button onClick={onCancel} className={styles.cancelButton} variant="outlined" color="primary" disabled={isAnyLoading}>
        {t("crewMember.scheduledTimeOff.buttons.cancel")}
      </Button>
      {!editMode && (
        <Button
          type="primary"
          onClick={onSaveAndAddNew}
          disabled={!isSaveEnabled || isAnyLoading}
          loading={saveAndAddNewLoading}
          className={styles.saveAndAddButton}
        >
          {t("crewMember.scheduledTimeOff.buttons.saveAndAddNew")}
        </Button>
      )}
      <Button type="primary" onClick={onSubmit} disabled={!isSaveEnabled || isAnyLoading} loading={saveLoading} className={styles.saveButton}>
        {editMode ? t("crewMember.scheduledTimeOff.buttons.saveChanges") : t("crewMember.scheduledTimeOff.buttons.save")}
      </Button>
    </Flex>
  )
}

ModalFooter.propTypes = {
  editMode: PropTypes.bool.isRequired,
  isSaveEnabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSaveAndAddNew: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saveLoading: PropTypes.bool,
  saveAndAddNewLoading: PropTypes.bool
}

export default ModalFooter
